export enum InterimCareSummarySupportStatus {
  unknown = 'Unknown',
  booked = 'Booked',
  attended = 'Attended',
  cancelled = 'Cancelled',
  missed = 'Missed',
}
